import Vue from "vue";
import { VueAuth0 } from "@tt/vue-auth0";
import EnvProvider from "@tt/vue-environment/EnvProvider";// import router from "@/router";

let domain = EnvProvider.value("AUTH0_DOMAIN");
let clientId = EnvProvider.value("AUTH0_CLIENT_ID");
let audience = EnvProvider.value("AUTH0_AUDIENCE");
let organization = EnvProvider.value("AUTH0_ORGANIZATION");

Vue.use(VueAuth0, {
  domain,
  clientId,
  audience,
  organization
});
